import * as yup from 'yup';

const PostcodeValidationSchema = yup
  .string()
  .matches(/\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/, {
    message: 'Please enter a correct email address',
  });

export default PostcodeValidationSchema;
